export const BRIEF_ENDPOINT =
  process.env.BUN_PUBLIC_BRIEF_ENDPOINT || "wss://brief.werknaam.eu/v1/sync";

export const BRIEF_API_BASE = BRIEF_ENDPOINT
  .replace("wss://", "https://")
  .replace("ws://", "http://")
  .replace("/v1/sync", "");
